import { CreditAgreement } from '@finley-technologies/finley-types';

import { BaseUnusedFeeFormData } from '~/core/routes/settings/implementations/[implementationId]/facilities/[facilityId]/expense-mechanics/[expenseId]/UnusedFee';

const toNumber = (str: string | undefined) => {
  if (str === undefined) return null;
  const num = Number(str);
  return Number.isNaN(num) ? null : num;
};

export const getUnusedFeeFormValues = (
  capitalProviderSlug: string,
  unusedFeeLiabilityAccounts:
    | CreditAgreement.DomainEntity.LiabilityAccountProperty[]
    | undefined,
): BaseUnusedFeeFormData => {
  const unusedFeeLiabilityAccount = unusedFeeLiabilityAccounts?.find(
    (la) => la.counterpartySlug === capitalProviderSlug,
  );

  const result: BaseUnusedFeeFormData = {
    capitalProviderSlug,
    name: unusedFeeLiabilityAccount?.name ?? 'Unused Fee', // default name for a new fee
    value: toNumber(unusedFeeLiabilityAccount?.value),
    type: CreditAgreement.DomainEntity.PropertyType.LiabilityAccountProperty, // todo: @markhaghani add FE / GQL type here
    tAccount: 'unusedInterestExpense',
  };

  return result;
};
